import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';
import { Easing } from '@tweenjs/tween.js';
import AnimationClip from '../AnimationClip';
import CardComponent from '../../../Component/Level/Card';
import { AwaitIterators } from '../AnimationHelper';
import StreakBar from '../../../Prototype/UI/Level/StreakBar';

export class UndoMatch extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        StreakBar.instance.update({ isUndo: true });

        const transform: TransformComponent = gameObject.getComponent(
            TransformComponent
        );
        const cardComponent = gameObject.getComponent(CardComponent);

        const tween = this.getTween(transform.position);
        tween
            .to(
                {
                    x: cardComponent.x,
                    y: cardComponent.y,
                },
                300
            )
            .easing(Easing.Quadratic.InOut);

        const tweenRotation = this.getTween(transform);
        tweenRotation
            .to({ rotation: cardComponent.rotation }, 300)
            .easing(Easing.Quadratic.InOut);

        yield* AwaitIterators([
            this.startTween(tween),
            this.startTween(tweenRotation),
        ]);
    }
}
